module.exports = __webpack_public_path__ + "static/img/reddit.909b6a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/reddit.svg
// module id = 99
// module chunks = 2